<div class="filters">
    <tk-search 
        [control]="form.controls['Phrase']"
        [loading]="loading"
        (onEnterEvent)="onSearchEnter()"
        (onClearEvent)="onClearEnter()"
        (onFocusEvent)="onInputFocus($event)"
    ></tk-search>

    <div class="filters__controls">
        <app-filter-control
            *ngIf="filterTypeAlarmConfig"
            [hidden]="selectedTab !== EVENT_TYPE.Alarm"
            (onSubmitFilters$)="onSubmitFilters($event, filterTypeAlarmConfig)"
            [data]="filterTypeAlarmConfig"
            [optionsSelectedCount]="form.controls['EventActionTypeAlarm'].value ? 1 : 0"
            [selectedControlValue]="filtersAlarmTypesCurrentFilters"
            [isVisibleSearchInput]="true"
        ></app-filter-control>

        <app-filter-control
            *ngIf="filterEventTypeFuelConfig"
            [hidden]="selectedTab !== EVENT_TYPE.Fuel"
            (onSubmitFilters$)="onSubmitFiltersEventTypeFuel($event, filterEventTypeFuelConfig)"
            [data]="filterEventTypeFuelConfig"
            [optionsSelectedCount]="form.controls['EventActionTypeFuel'].value ? 1: 0"
            [selectedControlValue]="filtersEventTypeFuelCurrentFilters"
        ></app-filter-control>

        <app-filter-control
            *ngIf="filterEventTypeAreaConfig"
            [hidden]="selectedTab !== EVENT_TYPE.Area"
            (onSubmitFilters$)="onSubmitFiltersEventTypeArea($event, filterEventTypeAreaConfig)"
            [data]="filterEventTypeAreaConfig"
            [optionsSelectedCount]="form.controls['EventActionTypeArea'].value ? 1: 0"
            [selectedControlValue]="filterEventTypeAreaCurrentFilters"
        ></app-filter-control>

        <button
            (click)="toogleDatePicker$.emit()"
            [ngClass]="{
                'is-active': (isVisibleDatepicker || _selectedDateCalendar),
                'is-visible-datepicker': isVisibleDatepicker
            }"
            class="filters__controls__date-btn"
        >
            <span class="label">
                {{'date'|translate}}
                <ng-container *ngIf="_selectedDateCalendar">
                    | {{ _selectedDateCalendar[0] && (_selectedDateCalendar[0] | date: 'mediumDate' : '' : langauge) }}

                    <ng-container *ngIf="!ifDateDayIsSame">
                        - {{ _selectedDateCalendar[1] && (_selectedDateCalendar[1] | date: 'mediumDate' : '' : langauge) }}
                    </ng-container>
                </ng-container> 
            </span>
            <button class="toggle-btn">
                <i class="pi pi-chevron-down icon"></i>
            </button>
        </button>
    </div>
</div>